﻿<template>
    <div class="slideout-content">

        <div id="tours" class="w-full">
            <h3>Select A Trip</h3>
            <p v-if="taglineCheck() == 'TOURSDATE'">
                There are <strong>{{FilteredProducts(tours_selected.products).length}} tours</strong> departing on <strong>{{search_date()}}</strong>.
            </p>
            <p v-if="taglineCheck() == 'DATE' ">
                These tours are departing on <strong>{{search_date()}}</strong>.
            </p>
            <p v-if="taglineCheck() == 'TOURS'">
                There are <strong>{{FilteredProducts(tours_selected.products).length}} tours</strong> departing on this day.
            </p>
            <p v-if="taglineCheck() == ''">
                Theres tours are departing on this day.
            </p>
            <div class="card-group">
                <div class="card-h list mt-8" v-for="product in FilteredProducts(tours_selected.products)" :key="product.id">
                    <div class="flex flex-col md:flex-row border border-form rounded-lg shadow bg-white mx-0 md:mx-4 overflow-hidden">
                        <!-- IMAGE -->
                        <div class="w-full md:w-4/12 h-56 md:h-auto relative overflow-hidden rounded-t-lg md:rounded-t-none md:rounded-l-lg flex-shrink-0">
                            <img class="h-full w-full object-cover" :src="image(product)" :alt="imageAltText(product)">
                        </div>
                        <!-- CONTENT + PRICE SIDEBAR: proper row/column responsive -->
                        <div class="flex flex-col md:flex-row w-full md:w-8/12 md:items-center px-4 py-4">
                            <!-- Main Tour Content -->
                            <div class="flex-grow md:pr-8">
                                <span v-if="isAgent_Login() && !isAAT()" class="font-semibold">{{ getBrand(product.brand) }}</span>
                                <p class="mt-2">
                                    <span class="icon small inline flex">
                                        <!-- SVG CLOCK ICON -->
                                        <div v-if="isAAT()">{{ duration(product) }}</div>
                                        <div v-else>{{ durationInDays(product) }}</div>
                                    </span>
                                </p>
                                <h5>
                                    <a href="" class="text-heading">{{ product.name }}</a>
                                </h5>
                                <p>Departs from {{ product.start_location.city }}</p>
                                <p>{{ removeHtmlTags(getDescription(product)) }}</p>
                                <div class="flex items-center mt-4">
                                    <p class="icon inline">
                                        <a :href="product.web_url" target="_blank" class="text-sm font-semibold text-link cursor-pointer">
                                            See tour details
                                        </a>
                                    </p>
                                </div>
                                <div class="flex flex-row items-center gap-1 mt-2">
                                    <div class="flex flex-col md:flex-row items-start md:items-center gap-1 w-full">
                                        <div class="flex flex-row items-baseline gap-1">
                                            <span class="font-bold text-pink-600 text-lg md:text-2xl">From</span>
                                            <span class="text-2xl md:text-4xl font-bold">{{ price(product) }}</span>
                                            <span class="font-semibold text-base md:text-lg align-super ml-1">{{ currency() }}</span>
                                            <span class="text-base md:text-lg text-body ml-1">per person</span>
                                        </div>
                                        <a
                                            href=""
                                            @click.prevent="product_selected(product)"
                                            class="btn px-3 py-2 bg-heading text-white rounded text-base md:text-md font-bold hover:bg-action hover:text-white hover:no-underline cursor-pointer text-center md:ml-auto mt-2 md:mt-0 w-full md:w-auto"
                                        >
                                            Dates & prices
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="slideout" :hidden="isHidden" 
            x-transition:enter="transition ease-out duration-500 -mr-64"
            x-transition:enter-start=""
            x-transition:enter-end="transform -translate-x-64"
            x-transition:leave="transform ease-out duration-75"
            x-transition:leave-start=""
            x-transition:leave-end="transform translate-x-64"
            style="z-index: 201 !important;">
            <div class="slideout-inner">
                <button class="close no-bg" @click="isHidden = true"></button>

                <div class="slideout-content">
                    <itinerary :tour_id="tour_id" :banner="true" ref="itinerary" v-if="!isHidden"></itinerary>
                </div>
            </div>

        </div>
    </div>
</template>

<script lang="ts" src="./tour_list.ts"></script>